/* eslint-disable tailwindcss/no-custom-classname */
import { useTranslation } from '@dagens/frontend-i18n';
import { FC } from 'react';
import Select from 'react-select';

import { FormFieldInputProps } from '../form-field/types';
import { SelectMultiClearIndicator } from './clear-indicator';
import { SelectMultiDropdownIndicator } from './dropdown-indicator';
import { SelectMultiOption } from './option';
import { SelectMultiRemove } from './remove';
import { selectMultiStyles } from './styles';
import { Option } from './types';

type Props = FormFieldInputProps & {
  options: readonly Option[];
  value: readonly Option[];
  onChange: (newValue: readonly Option[]) => void;
};

export const SelectMulti: FC<Props> = ({
  options,
  value,
  onChange,
  invalid,
  showError
}) => {
  const { t } = useTranslation();
  return (
    <Select<Option, true>
      placeholder={t('common:MultiSelectPlaceholder')}
      isMulti
      value={value}
      name="multi-select"
      onChange={onChange}
      options={options}
      className="basic-multi-select"
      classNamePrefix="select"
      styles={selectMultiStyles({ showError: invalid && showError })}
      components={{
        MultiValueRemove: SelectMultiRemove,
        Option: SelectMultiOption,
        ClearIndicator: SelectMultiClearIndicator,
        DropdownIndicator: SelectMultiDropdownIndicator
      }}
    />
  );
};

export type SelectMultiProps = Props;
